import { Breadcrumbs } from '@root/types';
import { Actions } from '../actions/ui';

export type UIStoreState = {
  breadcrumbs: Breadcrumbs;
};

export const defaultState: UIStoreState = {
  breadcrumbs: [],
};
export default function UIReducer(state = defaultState, action: Actions): UIStoreState {
  if (action.type === 'ADD_BREADCRUMBS') {
    const { breadcrumbs } = action.payload;

    return {
      ...state,
      breadcrumbs,
    };
  }

  if (action.type === 'REMOVE_BREADCRUMBS') {
    return {
      ...state,
      breadcrumbs: defaultState.breadcrumbs,
    };
  }

  return state;
}
